module.exports = __webpack_public_path__ + "img/notifications.d4bcab3d.svg";